export default function Menu({
    isOpen
}){
    return(
        <>
     <div className="menu-tab">
  <div className="bar bar1"/>
  <div className="bar bar2"/>
  <div className="bar bar3"/>
  </div>
  <style jsx="true">{
    `
    .menu-tab{
        width: 2rem;
        height: 2rem;
        display: flex;
        justify-content: space-around;
        flex-flow: column nowrap;
        z-index: 10;
      }
      .bar{
                width:2rem;
                height:0.25rem; 
                border-radius:10px
               background-color:#000;
               margin-top:2px;
               transform-origin:1px;
                transition:.5s ease-in-out;  
                cursor:pointer 
              }
              .bar1{
                transform: ${ isOpen ? 'rotate(45deg)' : 'rotate(0)'};
                background-color:white;
            }
            .bar2{
                transform: ${ isOpen ? 'translateX(100%)' : 'translateX(0)'};
                opacity: ${ isOpen ? 0 : 1};
                background-color:white;
            }
            .bar3{
                transform: ${ isOpen ? 'rotate(-45deg)' : 'rotate(0)'};
                background-color:white;
            }
    `}
  </style>
  
        </>
    )
}